import {format, getDate, getMonth, getYear, setDefaultOptions} from "date-fns"
import { formatInTimeZone } from "date-fns-tz";
import {fr} from "date-fns/locale"

setDefaultOptions({locale: fr})
const timeZone = "Europe/Paris"

export function getToday(endOfDay: boolean = true) {
    if (endOfDay) {
        return format(new Date(getYear(new Date()), getMonth(new Date()), getDate(new Date()), 23, 59), "yyyy-MM-dd HH:mm")
    }
    
    return format(new Date(), "yyyy-MM-dd")
}

export function getFormattedLocalisedDate(date: Date, formatDate: string) {
    return formatInTimeZone(date, timeZone, formatDate, { locale: fr });
}

export function getFormattedUtcTime(date: Date): string {
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
}

export function getFormattedUtcTimeFromString(date: string|undefined): string {
    if (date == undefined) {
        return ''
    }
    const hours = date.split(' ')[1].substring(0,2)
    const minutes = date.split(' ')[1].substring(3,5)
    return `${hours}:${minutes}`
}